<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062847355_Contents#r_idParaDest-2"><i><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"></span></i>Dedication</a></h2>
<p class="dedi">TO ALL OF THE FRIENDS I’VE FOUND</p>
<p class="dedi">ALONG THE WAY,</p>
<p class="dedi">AND ALL THE ONES LEFT TO FIND.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062847355_Dedication.vue?c9fd9458